<div class="level-bar" [class]="adnSkill ? 'adnReportStyle' : ''">
  <!-- Barra de progreso en test no ADN-->
  <ng-container *ngIf="!adnSkill">
    <div class="arrow" [ngStyle]="{ left: 'calc(' + value + '% - 15px)' }">
      <svg viewBox="0 0 32 32">
        <g id="arrow_down">
          <path d="M26.29,20.29,18,28.59V0H16V28.59L7.71,20.29,6.29,21.71l10,10a1,1,0,0,0,1.41,0l10-10Z" [attr.fill] ="this.colors.tertiaryColor"/>
        </g>
      </svg>
    </div>
    <div class="progress">
        <div class="progress-bar" role="progressbar" [style.background-color]="(hide && value > 25) ? this.colors.nonaryColor : this.colors.tertiaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          <span *ngIf="!hide || value <= 25" class="body-xxs">{{ 'COMMON.BEGINNER' | translate }}</span>
        </div>
        <div class="progress-bar" role="progressbar" [style.background-color]="(hide && (value <= 25 || value > 50)) ? this.colors.nonaryColor : this.colors.tertiaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          <span *ngIf="!hide || (value > 25 && value <= 50)" class="body-xxs">{{ 'COMMON.BASIC' | translate }}</span>
        </div>
        <div class="progress-bar" role="progressbar" [style.background-color]="(hide && (value <= 50 || value > 75)) ? this.colors.nonaryColor : this.colors.tertiaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          <span *ngIf="!hide || (value > 50 && value <= 75)" class="body-xxs">{{ 'COMMON.INTERMEDIATE' | translate }}</span>
        </div>
        <div class="progress-bar" role="progressbar" [style.background-color]="(hide && value <= 75) ? this.colors.nonaryColor : this.colors.tertiaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
          <span *ngIf="!hide || value > 75" class="body-xxs">{{ 'COMMON.EXPERT' | translate }}</span>
        </div>
      </div>
  </ng-container>

  <!-- Barra de progreso en test de ADN -->
  <ng-container *ngIf="adnSkill">
    <!-- Marker de puntuación para Consultor -->
    <ng-container *ngIf="adnSkill.reportType == 2">
      <div class="score-container" *ngIf="!adnSkill.adjustment || adnSkill.interview">
        <div class="marker skillValue" [ngStyle]="{ left: 'calc(' + adnSkill.value + '0% - 35px)' }">
            <span class="score">{{ adnSkill.value }}</span>
            <div class="arrow">
              <svg viewBox="0 0 32 32">
                <g id="arrow_down">
                  <path d="M26.29,20.29,18,28.59V0H16V28.59L7.71,20.29,6.29,21.71l10,10a1,1,0,0,0,1.41,0l10-10Z" [attr.fill] ="this.colors.tertiaryColor"/>
                </g>
              </svg>
            </div>
        </div>
      </div>
      <div class="score-container" *ngIf="adnSkill.adjustment && !adnSkill.interview">
        <div *ngIf="adnSkill.idealProfileMinValue" class="marker idealProfileMinValue" [ngStyle]="{ left: 'calc(' + adnSkill.idealProfileMinValue + '0% - 35px)' }">
            <span class="score">{{ adnSkill.idealProfileMinValue }}</span>
            <div class="arrow">
              <svg viewBox="0 0 32 32">
                <g id="arrow_down">
                  <path d="M26.29,20.29,18,28.59V0H16V28.59L7.71,20.29,6.29,21.71l10,10a1,1,0,0,0,1.41,0l10-10Z" [attr.fill] ="this.colors.tertiaryColor"/>
                </g>
              </svg>
            </div>
        </div>
        <div class="marker" [ngClass]="!adnSkill.idealProfileMinValue ? 'skillValueNoIdeal' : (adnSkill.value < adnSkill.idealProfileMinValue ? 'skillValueNoAdjust' : 'skillValueAdjust')" [ngStyle]="{ left: 'calc(' + adnSkill.value + '0% - 35px)' }">
            <span class="score">{{ adnSkill.value }}</span>
            <div class="arrow">
              <svg viewBox="0 0 32 32">
                <g id="arrow_down">
                  <path d="M26.29,20.29,18,28.59V0H16V28.59L7.71,20.29,6.29,21.71l10,10a1,1,0,0,0,1.41,0l10-10Z" [attr.fill] ="this.colors.tertiaryColor"/>
                </g>
              </svg>
            </div>
        </div>
      </div>
    </ng-container>
    <div class="progress" [class]="adnSkill.reportType !== 2 ? 'mar-t-20' : ''">
      <div class="progress-bar" role="progressbar" [style.background-color]="(hide && adnSkill.rangeId === 1) ? this.colors?.tertiaryColor : this.colors?.nonaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
        <span class="body-xxs" *ngIf="!hide || adnSkill.rangeId === 1">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.LOW_DEVELOPMENT' | translate }}</span>
      </div>
      <div class="progress-bar" role="progressbar" [style.background-color]="(hide && adnSkill.rangeId === 2) ? this.colors?.tertiaryColor : this.colors?.nonaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
        <span class="body-xxs" *ngIf="!hide || adnSkill.rangeId === 2">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.MEDIUM_DEVELOPMENT' | translate }}</span>
      </div>
      <div class="progress-bar" role="progressbar" [style.background-color]="(hide && adnSkill.rangeId === 3) ? this.colors?.tertiaryColor : this.colors?.nonaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
        <span class="body-xxs" *ngIf="!hide || adnSkill.rangeId === 3">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.GOOD_DEVELOPMENT' | translate }}</span>
      </div>
      <div class="progress-bar" role="progressbar" [style.background-color]="adnSkill.rangeId === 4 ? this.colors?.tertiaryColor : this.colors?.nonaryColor" aria-valuenow="25" aria-valuemin="0" aria-valuemax="100">
        <span class="body-xxs" *ngIf="!hide || adnSkill.rangeId === 4">{{ 'REPORT.CT.ADN.GENERAL.RESULTSCHART.CHART.LEGEND.EXCELENT_DEVELOPMENT' | translate }}</span>
      </div>
    </div>
  </ng-container>
</div>
